export default __webpack_public_path__ + "static/media/721.9ba9aac0.png";